export default {
  withoutBackboxLabel: {
    id: 'buyback_refurbisher_listing_without_backbox_label',
    defaultMessage: 'Without BackBox',
  },
  withBackboxLabel: {
    id: 'buyback_refurbisher_listing_with_backbox_label',
    defaultMessage: 'With BackBox',
  },
  offlineLabel: {
    id: 'buyback_refurbisher_listing_offline_label',
    defaultMessage: 'Offline',
  },
}
